<template>
  <div>
    <base-card :with_title="false">
      <template slot="content">
        <v-data-table
          :headers="headers"
          :items="companies"
          class="elevation-0"
          :loading="loading"
          :search="search"
          hide-default-footer
        >

          <template v-slot:item.status="{item}">
            <v-switch inset dense v-model="item.status" false-value="inactive" true-value="active"
              @change="updateCompanyStatus(item)"
            ></v-switch>
          </template>

          <template v-slot:item.pay_status="{item}">
            {{ $t(`companies.pay_statuses.${item.pay_status}`) }}
          </template>

          <template v-slot:item.actions="{item}">
            <v-btn icon small color="primary" @click="showCompany(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="primary" @click="showCompanyUsers(item)">
              <v-icon small>mdi-account-group</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </template>
      <template></template>
    
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'CompanyList',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      companies: [],
      search: null,
      selectedRow: null,
      headers: [
        {text: this.$t('status'), value: 'status',},
        {text: this.$t('name'), value: 'name',},
        {text: this.$tc('companies.pay_status_form_label', 2), value: 'pay_status',},
        {text: this.$tc('companies.payment_option_form_label', 2), value: 'payment_option',},
        {text: this.$t('companies.plan_form_label'), value: 'plan',},
        {text: this.$t('companies.renewal_date_form_label'), value: 'renewal_date',},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      sortBy: '',
      sortDesc: null,
    }
  },
  methods: {
    updateCompanyStatus(item){
      let {id, status} = item
      Api.Company.update({id, status}).then(r=> r.data).then(d=> {
        console.log({d});
      }).catch(err=> {
        console.log({err});
      })
    },
    getCompanies() {
      this.loading = true
      Api.Company.index().then(r=>r.data).then(d=> {
        this.companies = [...d]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    showCompany(item){
      this.$router.push({name: 'ShowCompany', params: {id: item.id}})
    },
    showCompanyUsers(item){
      this.$router.push({name: 'ShowCompanyUsers', params: {id: item.id}})
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getCompanies();
  },
  watch: {
    '$route'(nv,ov) {
      // console.log({ov, nv});
      if (['ShowCompany', 'NewCompany'].includes(ov.name)){
        this.getCompanies()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>